/* Native Horizon product tabs, Reviews.io and PDF generator; isolated preview adapter. */
window.initialiseLighteezProductTabs = function(root, config) {

  function initProductTabBar() {
    var bar = root.querySelector('#product-tab-bar');
    if (!bar) return;

    var tablist = bar.querySelector('[role="tablist"]');
    var tabs = bar.querySelectorAll('.ptb__tab');
    var panels = root.querySelectorAll('.ptb__panel');
    var reviewsInitialised = false;
    var expertAnswersLoaded = false;
    var expertAnswersSku = config.reviewSku;

    var activateTab = function(tab, shouldFocus = true) {
      /* Update tab states */
      tabs.forEach(function(t) {
        t.classList.remove('ptb__tab--active');
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });

      tab.classList.add('ptb__tab--active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      if (shouldFocus) tab.focus();

      /* Show/hide panels */
      var targetId = tab.getAttribute('data-target');
      panels.forEach(function(panel) {
        if (panel.id === targetId) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      /* Lazy-init Reviews.io widget on first Reviews tab click — delay
         to allow browser to paint the now-visible panel before widget mounts */
      if (targetId === 'tab-panel-reviews' && !reviewsInitialised) {
        reviewsInitialised = true;
        setTimeout(initReviewsWidget, 50);
      }

      /* Lazy-init Expert Answers widget on first Ask a Question tab click */
      if (targetId === 'tab-panel-ask' && !expertAnswersLoaded) {
        expertAnswersLoaded = true;
        setTimeout(initExpertAnswers, 50);
      }

      /* Keep accordion state in sync */
      syncAccordionState(targetId);
    };

    /* Reviews.io polaris widget — script and widget both deferred until first tab click */
    function showReviewsError() {
      var container = root.querySelector('#ptb-reviews-widget');
      if (container) {
        container.innerHTML = '<p style="font-size:0.9375rem;color:#6b7280;line-height:1.6;">Reviews could not be loaded. Please <a href="javascript:location.reload()" style="color:#1e3a5f;text-decoration:underline;">refresh the page</a> to try again.</p>';
      }
    }

    function renderReviewsWidget() {
      if (!root.isConnected) return;
      if (typeof ReviewsWidget === 'undefined') {
        showReviewsError();
        return;
      }
      new ReviewsWidget('#ptb-reviews-widget', {
        store: 'simple-lighting',
        widget: 'polaris',
        options: {
          types: 'product_review',
          per_page: 10,
          product_review: {
            sku: config.reviewSku,
            hide_if_no_results: false
          },
          header: {
            enable_summary: true,
            enable_write_review: true,
            use_write_review_button: true,
            enable_ask_question: false,
            always_show: true,
            rating_decimal_places: 2
          },
          filtering: {
            enable: true,
            enable_sorting: true,
            enable_ratings_filters: true,
            enable_text_search: true
          },
          reviews: {
            enable_avatar: true,
            enable_reviewer_name: true,
            enable_reviewer_address: true,
            reviewer_address_format: 'city, country',
            enable_ratings: true,
            enable_date: false,
            enable_share: true,
            enable_images: true,
            enable_replies: true,
            enable_helpful_vote: true
          }
        }
      });
    }

    function initReviewsWidget() {
      /* If polaris is already loaded (e.g. by another section on the page), render directly */
      if (typeof ReviewsWidget !== 'undefined') {
        renderReviewsWidget();
        return;
      }

      /* If a previous click already started loading the script, wait for its onload */
      var existing = document.getElementById('polaris-build-js');
      if (existing) {
        existing.addEventListener('load', renderReviewsWidget);
        existing.addEventListener('error', showReviewsError);
        return;
      }

      /* Inject polaris/build.js on demand */
      var script = document.createElement('script');
      script.id = 'polaris-build-js';
      script.src = 'https://widget.reviews.io/polaris/build.js';
      script.onload = renderReviewsWidget;
      script.onerror = showReviewsError;
      document.head.appendChild(script);
    }

    /* Reviews.io Expert Answers widget — deferred until first Ask a Question tab click */
    var qaWidgetCssConfig = [
      ['--base-font-size: 16px'],
      ['--common-button-font-family: inherit'],
      ['--common-button-font-size: 16px'],
      ['--common-button-font-weight: 500'],
      ['--common-button-letter-spacing: 0'],
      ['--common-button-text-transform: none'],
      ['--common-button-vertical-padding: 10px'],
      ['--common-button-horizontal-padding: 25px'],
      ['--common-button-border-width: 2px'],
      ['--common-button-border-radius: 0px'],
      ['--primary-button-bg-color: #1e3a5f'],
      ['--primary-button-border-color: #1e3a5f'],
      ['--primary-button-text-color: #ffffff'],
      ['--secondary-button-bg-color: transparent'],
      ['--secondary-button-border-color: #1e3a5f'],
      ['--secondary-button-text-color: #1e3a5f'],
      ['--heading-text-color: #1e3a5f'],
      ['--heading-text-font-weight: 600'],
      ['--heading-text-font-family: inherit'],
      ['--heading-text-line-height: 1.4'],
      ['--heading-text-letter-spacing: 0'],
      ['--heading-text-transform: none'],
      ['--body-text-color: #1a1a1a'],
      ['--body-text-font-weight: 400'],
      ['--body-text-font-family: inherit'],
      ['--body-text-line-height: 1.4'],
      ['--body-text-letter-spacing: 0'],
      ['--body-text-transform: none'],
      ['--inputfield-text-font-family: inherit'],
      ['--input-text-font-size: 14px'],
      ['--inputfield-text-font-weight: 400'],
      ['--inputfield-text-color: #1a1a1a'],
      ['--inputfield-border-color: rgba(0,0,0,0.2)'],
      ['--inputfield-background-color: transparent'],
      ['--inputfield-border-width: 1px'],
      ['--inputfield-border-radius: 6px'],
      ['--common-border-color: rgba(0,0,0,0.15)'],
      ['--common-border-width: 1px'],
      ['--pagination-tab-text-color: #1e3a5f'],
      ['--pagination-tab-active-text-color: #1e3a5f'],
      ['--pagination-tab-active-border-color: #1e3a5f'],
      ['--pagination-tab-border-width: 3px']
    ];

    function initExpertAnswers() {
      /* Inject CSS files if not yet loaded */
      if (!document.getElementById('qa-widget-css')) {
        var link1 = document.createElement('link');
        link1.id = 'qa-widget-css';
        link1.rel = 'stylesheet';
        link1.href = 'https://assets.reviews.io/css/widgets/qna-widget.css';
        document.head.appendChild(link1);

        var link2 = document.createElement('link');
        link2.id = 'qa-widget-icons-css';
        link2.rel = 'stylesheet';
        link2.href = 'https://assets.reviews.io/iconfont/reviewsio-icons/style.css';
        document.head.appendChild(link2);
      }

      /* Inject JS if not yet loaded, then render */
      if (!document.getElementById('qa-widget-js')) {
        var script = document.createElement('script');
        script.id = 'qa-widget-js';
        script.src = 'https://widget.reviews.io/questions-answers/new/dist.js';
        script.onload = function() {
          renderQAWidget();
        };
        script.onerror = function() {
          var c = root.querySelector('#questions-widget');
          if (c) c.innerHTML = '<p style="font-size:0.9375rem;color:#6b7280;line-height:1.6;">Q&amp;A could not be loaded. Please <a href="javascript:location.reload()" style="color:#1e3a5f;text-decoration:underline;">refresh the page</a> to try again.</p>';
        };
        document.head.appendChild(script);
      } else {
        renderQAWidget();
      }
    }

    function renderQAWidget() {
      if (!root.isConnected) return;
      if (typeof questionsWidgetNew !== 'function') return;
      var container = root.querySelector('#questions-widget');
      if (container) container.innerHTML = '';
      questionsWidgetNew('questions-widget', {
        store: 'simple-lighting',
        group: expertAnswersSku,
        hideDates: true,
        css: qaWidgetCssConfig
      });
    }

    /* No variant change handler needed — group includes all variant SKUs */

    /* Click handler */
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activateTab(this);
      });
    });

    /* Keyboard navigation — arrow keys, Home, End */
    if (tablist) {
      tablist.addEventListener('keydown', function(e) {
        var tabArray = Array.from(tabs);
        var currentIndex = tabArray.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        var newIndex;
        switch (e.key) {
          case 'ArrowRight':
            newIndex = (currentIndex + 1) % tabArray.length;
            break;
          case 'ArrowLeft':
            newIndex = (currentIndex - 1 + tabArray.length) % tabArray.length;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = tabArray.length - 1;
            break;
          default:
            return;
        }

        e.preventDefault();
        activateTab(tabArray[newIndex]);
      });
    }
    /* ── Accordion (mobile) ── */
    var accItems = root.querySelectorAll('[data-ptb-acc-item]');
    var isMobile = function() { return window.innerWidth < 750; };

    /* Sync accordion open/close state to match a given panel ID */
    function syncAccordionState(targetId) {
      accItems.forEach(function(item) {
        var toggle = item.querySelector('[data-ptb-acc-toggle]');
        if (toggle && toggle.getAttribute('data-ptb-acc-toggle') === targetId) {
          item.classList.add('ptb-acc__item--open');
          toggle.setAttribute('aria-expanded', 'true');
          var body = item.querySelector('.ptb-acc__body');
          if (body) body.style.maxHeight = 'none';
        } else {
          item.classList.remove('ptb-acc__item--open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          var body2 = item.querySelector('.ptb-acc__body');
          if (body2) body2.style.maxHeight = '0';
        }
      });
    }

    function openAccItem(item) {
      var body = item.querySelector('.ptb-acc__body');
      var header = item.querySelector('.ptb-acc__header');
      item.classList.add('ptb-acc__item--open');
      if (header) header.setAttribute('aria-expanded', 'true');

      /* Animate max-height from 0 to scrollHeight */
      if (body) {
        var sh = body.scrollHeight;
        if (sh === 0) {
          /* Content not yet rendered (e.g. Reviews widget) — skip animation */
          body.style.maxHeight = 'none';
        } else {
          body.style.maxHeight = sh + 'px';
          /* After transition, remove fixed max-height so content can reflow */
          var onEnd = function() {
            body.removeEventListener('transitionend', onEnd);
            /* Guard: only set none if still open (prevents race on rapid toggle) */
            if (item.classList.contains('ptb-acc__item--open')) {
              body.style.maxHeight = 'none';
            }
          };
          body.addEventListener('transitionend', onEnd);
        }
      }

      /* Sync desktop tab to match */
      var toggle = item.querySelector('[data-ptb-acc-toggle]');
      if (toggle) {
        var panelId = toggle.getAttribute('data-ptb-acc-toggle');
        tabs.forEach(function(t) {
          if (t.getAttribute('data-target') === panelId) {
            t.classList.add('ptb__tab--active');
            t.setAttribute('aria-selected', 'true');
            t.setAttribute('tabindex', '0');
          } else {
            t.classList.remove('ptb__tab--active');
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
          }
        });
      }

      /* Trigger Reviews.io widget if opening Reviews panel */
      if (toggle && toggle.getAttribute('data-ptb-acc-toggle') === 'tab-panel-reviews' && !reviewsInitialised) {
        reviewsInitialised = true;
        setTimeout(function() {
          initReviewsWidget();
          window.dispatchEvent(new Event('resize'));
        }, 50);
      }

      /* Trigger Expert Answers widget if opening Ask a Question panel */
      if (toggle && toggle.getAttribute('data-ptb-acc-toggle') === 'tab-panel-ask' && !expertAnswersLoaded) {
        expertAnswersLoaded = true;
        setTimeout(initExpertAnswers, 50);
      }
    }

    function closeAccItem(item) {
      var body = item.querySelector('.ptb-acc__body');
      var header = item.querySelector('.ptb-acc__header');
      item.classList.remove('ptb-acc__item--open');
      if (header) header.setAttribute('aria-expanded', 'false');

      if (body) {
        /* Set explicit height first so transition can animate from it */
        body.style.maxHeight = body.scrollHeight + 'px';
        /* Force reflow then set to 0 */
        body.offsetHeight; // eslint-disable-line no-unused-expressions
        body.style.maxHeight = '0';
      }
    }

    accItems.forEach(function(item) {
      var header = item.querySelector('.ptb-acc__header');
      if (!header) return;

      header.addEventListener('click', function() {
        if (!isMobile()) return;

        var isOpen = item.classList.contains('ptb-acc__item--open');

        if (isOpen) {
          closeAccItem(item);
        } else {
          /* Collect all bodies involved in this switch */
          var bodiesToSwitch = [];
          var closingItem = null;
          accItems.forEach(function(other) {
            if (other !== item && other.classList.contains('ptb-acc__item--open')) {
              closingItem = other;
              var b = other.querySelector('.ptb-acc__body');
              if (b) bodiesToSwitch.push(b);
            }
          });
          var openingBody = item.querySelector('.ptb-acc__body');
          if (openingBody) bodiesToSwitch.push(openingBody);

          /* 1. Record header position */
          var headerTopBefore = header.getBoundingClientRect().top;

          /* 2. Kill transitions so height changes are instant */
          bodiesToSwitch.forEach(function(b) {
            b.style.transition = 'none';
          });

          /* 3. Close old + open new (instant, no animation) */
          if (closingItem) closeAccItem(closingItem);
          openAccItem(item);

          /* 4. Force layout so changes apply immediately */
          header.offsetHeight;

          /* 5. Correct scroll to keep header in same viewport spot */
          var headerTopAfter = header.getBoundingClientRect().top;
          var drift = headerTopAfter - headerTopBefore;
          if (Math.abs(drift) > 1) {
            window.scrollBy(0, drift);
          }

          /* 6. Re-enable transitions on next frame */
          requestAnimationFrame(function() {
            bodiesToSwitch.forEach(function(b) {
              b.style.transition = '';
            });
          });
        }
      });
    });

    /* ── Resize: fix max-height values when crossing breakpoint ── */
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (!isMobile()) {
          /* Desktop: clear inline max-height so CSS rule takes over */
          accItems.forEach(function(item) {
            var body = item.querySelector('.ptb-acc__body');
            if (body) body.style.maxHeight = '';
          });
          /* Reconcile [hidden] attributes to match the active desktop tab */
          var activeTab = bar.querySelector('.ptb__tab--active');
          if (activeTab) {
            var tid = activeTab.getAttribute('data-target');
            panels.forEach(function(panel) {
              if (panel.id === tid) panel.removeAttribute('hidden');
              else panel.setAttribute('hidden', '');
            });
          }
        } else {
          /* Mobile: ensure open item has max-height: none, closed have 0 */
          accItems.forEach(function(item) {
            var body = item.querySelector('.ptb-acc__body');
            if (!body) return;
            if (item.classList.contains('ptb-acc__item--open')) {
              body.style.maxHeight = 'none';
            } else {
              body.style.maxHeight = '0';
            }
          });
        }
      }, 100);
    }, {signal: config.signal});

    if(config.activePanel){const selected=Array.from(tabs).find(tab=>tab.dataset.target===config.activePanel);if(selected)activateTab(selected,false);}
  }

  initProductTabBar();

  /* ── PDF Spec Sheet Generator ── */
  (function() {
    function init() {
      var btn = root.querySelector('#ptb-download-spec-btn');
      var errEl = root.querySelector('#ptb-download-error');
      if (!btn) return;

      function showError(msg) {
        if (errEl) { errEl.textContent = msg; errEl.removeAttribute('hidden'); }
      }

      function resetBtn() {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = 'Download Specification Sheet';
      }

      function loadJsPDF() {
        return new Promise(function(resolve, reject) {
          if (window.jspdf) return resolve();
          var s = document.createElement('script');
          s.src = config.pdfUrl;
          s.onload = resolve;
          s.onerror = function() { reject(new Error('Failed to load PDF library.')); };
          document.head.appendChild(s);
        });
      }

      function loadImageAsDataUrl(url) {
        return new Promise(function(resolve) {
          var timer = setTimeout(function() { resolve(null); }, 8000);
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            clearTimeout(timer);
            var c = document.createElement('canvas');
            c.width = img.naturalWidth;
            c.height = img.naturalHeight;
            c.getContext('2d').drawImage(img, 0, 0);
            try { resolve(c.toDataURL('image/png')); } catch(e) { resolve(null); }
          };
          img.onerror = function() { clearTimeout(timer); resolve(null); };
          img.src = url;
        });
      }

      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Generating PDF…';
        if (errEl) errEl.setAttribute('hidden', '');

        var dataEl = root.querySelector('#ptb-spec-data');
        if (!dataEl) { showError('Product data not found.'); resetBtn(); return; }

        var data;
        try { data = JSON.parse(dataEl.textContent); } catch(e) { showError('Invalid product data.'); resetBtn(); return; }

        /* Load jsPDF on demand + pre-load images in parallel */
        Promise.all([
          loadJsPDF(),
          data.image ? loadImageAsDataUrl(data.image) : Promise.resolve(null),
          data.ce_logo_url ? loadImageAsDataUrl(data.ce_logo_url) : Promise.resolve(null),
          data.ukca_logo_url ? loadImageAsDataUrl(data.ukca_logo_url) : Promise.resolve(null),
          data.logo_url ? loadImageAsDataUrl(data.logo_url) : Promise.resolve(null)
        ]).then(function(results) {
          var productImg = results[1];
          var ceImg = results[2];
          var ukcaImg = results[3];
          var logoImg = results[4];

          var jsPDF = window.jspdf.jsPDF;
          var doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
          var pageW = 210;
          var marginL = 15;
          var marginR = 15;
          var contentW = pageW - marginL - marginR;
          var y = 15;

          function checkPage(needed) {
            if (y + needed > 275) {
              addFooter();
              doc.addPage();
              y = 15;
            }
          }

          function addFooter() {
            doc.setFontSize(7);
            doc.setTextColor(156, 163, 175);
            doc.text('Simple Lighting  |  simplelighting.co.uk  |  Generated ' + new Date().toLocaleDateString('en-GB'), pageW / 2, 290, { align: 'center' });
            doc.setDrawColor(188, 229, 251);
            doc.line(marginL, 285, pageW - marginR, 285);
          }

          /* ── Header ── */
          if (logoImg) {
            var logoH = 10;
            var logoW = 50;
            doc.addImage(logoImg, 'PNG', marginL, y, logoW, logoH);
          } else {
            doc.setFontSize(22);
            doc.setTextColor(30, 58, 95);
            doc.setFont('helvetica', 'bold');
            doc.text('Simple', marginL, y + 7);
            var simpleW = doc.getTextWidth('Simple');
            doc.setFont('helvetica', 'normal');
            doc.text(' Lighting', marginL + simpleW, y + 7);
          }
          doc.setFontSize(9);
          doc.setTextColor(107, 114, 128);
          doc.text('Technical Specification Sheet', pageW - marginR, y + 7, { align: 'right' });
          y += 12;
          doc.setDrawColor(30, 58, 95);
          doc.setLineWidth(0.5);
          doc.line(marginL, y, pageW - marginR, y);
          y += 10;

          /* ── Product Image ── */
          if (productImg) {
            checkPage(65);
            var imgW = 60;
            var imgH = 60;
            var imgX = (pageW - imgW) / 2;
            doc.addImage(productImg, 'PNG', imgX, y, imgW, imgH);
            y += imgH + 8;
          }

          /* ── Title / SKU / Price ── */
          checkPage(20);
          doc.setFontSize(16);
          doc.setTextColor(30, 58, 95);
          doc.setFont('helvetica', 'bold');
          var titleLines = doc.splitTextToSize(data.title || 'Product', contentW);
          doc.text(titleLines, marginL, y);
          y += titleLines.length * 7 + 2;

          doc.setFontSize(10);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(107, 114, 128);
          if (data.sku) {
            doc.text('SKU: ' + data.sku, marginL, y);
            y += 5;
          }
          if (data.price) {
            doc.text('Price: ' + data.price + ' inc. VAT', marginL, y);
            y += 5;
          }
          y += 5;

          /* ── Bullets ── */
          if (data.bullets && data.bullets.length) {
            checkPage(10 + data.bullets.length * 7);
            doc.setFontSize(12);
            doc.setTextColor(30, 58, 95);
            doc.setFont('helvetica', 'bold');
            doc.text('Key Features', marginL, y);
            y += 7;

            doc.setFontSize(9.5);
            data.bullets.forEach(function(b) {
              checkPage(8);
              doc.setTextColor(30, 58, 95);
              doc.text('\u2022', marginL + 2, y);
              var bulletX = marginL + 7;
              if (b.bold) {
                doc.setFont('helvetica', 'bold');
                doc.setTextColor(26, 26, 26);
                var boldText = b.bold;
                var maxBoldW = contentW - 12;
                while (doc.getTextWidth(boldText) > maxBoldW && boldText.length > 1) {
                  boldText = boldText.slice(0, -1);
                }
                doc.text(boldText, bulletX, y);
                var bw = doc.getTextWidth(boldText);
                doc.setFont('helvetica', 'normal');
                doc.setTextColor(75, 85, 99);
                var availW = Math.max(contentW - 9 - bw, 20);
                var restLines = doc.splitTextToSize(b.text || '', availW);
                if (restLines.length && restLines[0]) {
                  doc.text(restLines[0], bulletX + bw, y);
                  for (var rl = 1; rl < restLines.length; rl++) {
                    y += 5;
                    checkPage(6);
                    doc.text(restLines[rl], bulletX, y);
                  }
                }
              } else {
                doc.setFont('helvetica', 'normal');
                doc.setTextColor(75, 85, 99);
                var lines = doc.splitTextToSize(b.text || '', contentW - 9);
                doc.text(lines, bulletX, y);
                y += (lines.length - 1) * 5;
              }
              y += 6;
            });
            y += 3;
          }

          /* ── Variants Table ── */
          if (data.variants && data.variants.length) {
            var vRowH = 7;
            checkPage(vRowH * 2 + 9);

            doc.setFontSize(12);
            doc.setTextColor(30, 58, 95);
            doc.setFont('helvetica', 'bold');
            doc.text('Available Variants', marginL, y);
            y += 7;

            var cols = [
              { label: 'Variant', x: marginL, w: contentW * 0.45 },
              { label: 'SKU', x: marginL + contentW * 0.45, w: contentW * 0.3 },
              { label: 'Price', x: marginL + contentW * 0.75, w: contentW * 0.25 }
            ];

            /* Header row */
            doc.setFillColor(30, 58, 95);
            doc.rect(marginL, y, contentW, vRowH, 'F');
            doc.setFontSize(8.5);
            doc.setTextColor(255, 255, 255);
            doc.setFont('helvetica', 'bold');
            cols.forEach(function(c) { doc.text(c.label, c.x + 2, y + 5); });
            y += vRowH;

            /* Data rows */
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8.5);
            data.variants.forEach(function(v, i) {
              checkPage(vRowH + 2);
              if (i % 2 === 0) {
                doc.setFillColor(240, 247, 255);
                doc.rect(marginL, y, contentW, vRowH, 'F');
              }
              doc.setTextColor(26, 26, 26);
              doc.text(String(v.title || '').substring(0, 40), cols[0].x + 2, y + 5);
              doc.text(String(v.sku || ''), cols[1].x + 2, y + 5);
              doc.text(String(v.price || ''), cols[2].x + 2, y + 5);
              y += vRowH;
            });
            y += 8;
          }

          /* ── Technical Specifications Table ── */
          if (data.specs && data.specs.length) {
            var sRowH = 7;
            checkPage(sRowH * 2 + 9);

            doc.setFontSize(12);
            doc.setTextColor(30, 58, 95);
            doc.setFont('helvetica', 'bold');
            doc.text('Technical Specifications', marginL, y);
            y += 7;

            var specColW = contentW * 0.4;

            /* Header row */
            doc.setFillColor(30, 58, 95);
            doc.rect(marginL, y, contentW, sRowH, 'F');
            doc.setFontSize(8.5);
            doc.setTextColor(255, 255, 255);
            doc.setFont('helvetica', 'bold');
            doc.text('Specification', marginL + 2, y + 5);
            doc.text('Value', marginL + specColW + 2, y + 5);
            y += sRowH;

            /* Data rows */
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8.5);
            data.specs.forEach(function(s, i) {
              checkPage(sRowH + 2);
              if (i % 2 === 0) {
                doc.setFillColor(240, 247, 255);
                doc.rect(marginL, y, contentW, sRowH, 'F');
              }
              doc.setTextColor(26, 26, 26);
              doc.setFont('helvetica', 'bold');
              doc.text(String(s.label || ''), marginL + 2, y + 5);
              doc.setFont('helvetica', 'normal');
              doc.text(String(s.value || '').substring(0, 60), marginL + specColW + 2, y + 5);
              y += sRowH;
            });
            y += 8;
          }

          /* ── Certification Marks ── */
          if (ceImg || ukcaImg) {
            checkPage(30);
            doc.setFontSize(10);
            doc.setTextColor(107, 114, 128);
            doc.setFont('helvetica', 'normal');
            doc.text('Certifications', marginL, y);
            y += 5;
            var certX = marginL;
            if (ceImg) {
              doc.addImage(ceImg, 'PNG', certX, y, 16, 16);
              certX += 22;
            }
            if (ukcaImg) {
              doc.addImage(ukcaImg, 'PNG', certX, y, 16, 16);
            }
            y += 22;
          }

          /* ── Product URL ── */
          if (data.url) {
            checkPage(10);
            doc.setFontSize(8);
            doc.setTextColor(107, 114, 128);
            doc.text('View this product online: ' + data.url, marginL, y);
            y += 8;
          }

          /* ── Footer on last page ── */
          addFooter();

          /* ── Save ── */
          var filename = (data.handle || 'product') + '-spec-sheet.pdf';
          doc.save(filename);
          resetBtn();
        }).catch(function(e) {
          console.error('[PDF Spec Sheet]', e);
          showError('Failed to generate PDF: ' + (e.message || 'Unknown error') + '. Please try again.');
          resetBtn();
        });
      });
    }

    init();
  })();

};
